import React from "react";

const AgencyTaskboardMobileHeader = ({ onAddEntry }) => {
  return (
    <div className="px-4 py-3 bg-white flex justify-between items-center border-b border-[#E5E6E8]">
      <h1 className="text-lg font-bold text-[#202630]">Taskboard</h1>
      <button
        onClick={onAddEntry}
        className="bg-[#2283FF] text-white px-3 py-1.5 rounded-lg text-xs font-medium"
      >
        + Create folder
      </button>
    </div>
  );
};

export default AgencyTaskboardMobileHeader;